import React from "react";
import { BiLink } from "react-icons/bi";
import styled from "styled-components";
import { BASEURL, handleCopyClipBoard } from "../utils/common";

const ClipboardCopy = () => {
  return (
    <Button
      onClick={async () => {
        await handleCopyClipBoard(BASEURL);
      }}
    >
      <BiLink fontSize={24} />
      링크복사
    </Button>
  );
};

export default ClipboardCopy;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  height: 34.5px;

  font-size: 20px;
`;
